import MediaAPI from '../../api/media_api';
import fetchHookFactory from './fetchHookFactory';

export const [useMediaByIdApi] = fetchHookFactory(
  async (mediaId: number) => (await MediaAPI.getMediaById(mediaId)).data,
  'cache',
);
